import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import NewCorrespondenceForm from "./NewCorrespondence";
import CorrespondenceList from "./CorrespondenceList";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { LIST, CREATE } from "../../../../queries/correspondence.query";
import LoadingSpinner from "../../../../partials/loading";
import Pagination from "../../../../partials/pagination";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import FabButton from "../../../../partials/Buttons/FabButton";
import { EventEmitter } from "../../../../event/EventEmitter";
import { EVENT_TARGET, ACTION_TYPE } from "../../../../event/model";
import { sendNotification } from "../../../../sockette";

const CorrespondenceIndex = ({ match }) => {
    const title = "Patient Attachment";
    const [newForm, setNewForm] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(25);
    // patient id
    const { id } = match.params;
    // query
    const { loading, data, fetchMore, refetch } = useQuery(LIST, {
        variables: { page, limit, id },
        onError: (e) => toast.error(CleanMessage(e.message)),
        notifyOnNetworkStatusChange: true,
    });
    // Mutation
    const [CreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.CreateCorrespondent) {
                const { message } = d.CreateCorrespondent;
                toast.success(message);
                setNewForm(false);
                sendNotification(message, ACTION_TYPE.CREATE, EVENT_TARGET.ATTACHMENT);
            }
        },
    });

    EventEmitter.subscribe(EVENT_TARGET.ATTACHMENT, () => refetch());

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row justify-content-center">
                {newForm && (
                    <div className="col-12 fade-in m-b-20">
                        <div className="card">
                            <div className="card-head">
                                <header>New Attachment</header>
                            </div>
                            <div className="card-body height-min m-b-20">
                                <LoadingSpinner loading={cLoading} />

                                <NewCorrespondenceForm
                                    onCancel={() => setNewForm(false)}
                                    onSubmit={async (item) => {
                                        await CreateFunc({
                                            variables: {
                                                model: { ...item, patient: id },
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newForm && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>{title}</header>
                            </div>
                            <div className="card-body" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={loading} />

                                {data && (
                                    <CorrespondenceList
                                        items={data.GetCorrespondents.docs}
                                        onDownload={(path) => {
                                            document.location.href = path;
                                        }}
                                    />
                                )}
                            </div>
                            {data && (
                                <Pagination
                                    className="fade-in"
                                    {...data.GetCorrespondents}
                                    length={data.GetCorrespondents.docs.length}
                                    onPageClicked={(page) => {
                                        setPage(page);
                                        fetchMore({
                                            variables: { page },
                                            updateQuery: (prev, { fetchMoreResult }) => {
                                                if (!fetchMoreResult) return prev;
                                                return {
                                                    GetCorrespondents: fetchMoreResult.GetCorrespondents,
                                                };
                                            },
                                        });
                                    }}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>
            {!newForm && (
                <FabButton
                    title="New Attachment"
                    onClick={() => {
                        setNewForm(true);
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                    }}
                />
            )}
        </>
    );
};

export default CorrespondenceIndex;
